import React from "react";
import "./HTML_MAIN_CSS.css";

const HTML_Syllabus = () => {
  const syllabus = [
    {
      section: "1. Introduction",
      topics: [
        "What is HTML",
        "History and evolution of HTML",
        "HTML vs XHTML",
        "HTML Editors and Tools",
      ],
    },
    {
      section: "2. HTML Basic Structure",
      topics: [
        "HTML Document Structure",
        "HTML Doctype",
        "Head Section",
        "Title, Meta, and Charset",
        "Body Section",
      ],
    },
    {
      section: "3. Text Formatting",
      topics: [
        "Headings, Paragraphs, and Line Breaks",
        "Bold, Italic, Underline, Strikethrough",
        "Superscript and Subscript",
        "Semantic Elements: <strong>, <em>, <mark>, <small>, <abbr>",
        "Blockquotes and Citations",
      ],
    },
    {
      section: "4. HTML Links",
      topics: [
        "Hyperlinks using <a>",
        "Anchor Links / Bookmarks",
        "Link Colors and Styling",
        "Opening links in new tab",
      ],
    },
    {
      section: "5. HTML Images",
      topics: [
        "Adding Images using <img>",
        "Image Attributes (alt, width, height)",
        "Image Maps",
        "Background Images",
        "The <picture> element",
      ],
    },
    {
      section: "6. HTML Tables",
      topics: [
        "Creating Tables",
        "Table Headers",
        "Table Rows and Cells",
        "Colspan and Rowspan",
        "Table Styling, Padding & Spacing",
        "Table Borders",
        "Table Size and Alignment",
      ],
    },
    {
      section: "7. HTML Lists",
      topics: [
        "Ordered Lists <ol>",
        "Unordered Lists <ul>",
        "Definition Lists <dl>",
        "Nested Lists",
      ],
    },
    {
      section: "8. HTML Forms",
      topics: [
        "Form Elements",
        "Input Types",
        "Input Attributes",
        "Form Attributes",
        "Textarea, Select, Radio, Checkboxes, Buttons",
      ],
    },
    {
      section: "9. HTML Multimedia",
      topics: [
        "Audio <audio>",
        "Video <video>",
        "YouTube Embeds",
        "Plug-ins and Objects",
      ],
    },
    {
      section: "10. HTML Graphics",
      topics: [
        "Canvas <canvas>",
        "SVG <svg>",
      ],
    },
    {
      section: "11. HTML Layout & Styling",
      topics: [
        "Div and Span",
        "Classes and IDs",
        "Inline, Block, and Inline-block",
        "CSS Basics",
        "Background Colors and Images",
        "Text Colors, Link Colors",
        "Favicon",
        "Responsive HTML",
      ],
    },
    {
      section: "12. HTML Advanced Topics",
      topics: [
        "HTML Web APIs (Geolocation, Web Storage, Web Workers, SSE, Drag & Drop)",
        "HTML JavaScript Integration",
        "HTML URL Encoding",
        "HTML Entities and Symbols",
        "HTML Emojis",
        "HTML Comments",
        "HTML Semantics",
      ],
    },
    {
      section: "13. HTML Exercises & Examples",
      topics: [
        "HTML Exercises: Multiple Question Types",
        "HTML Quiz",
        "HTML Code Check / Correcting Code",
        "HTML Website Examples",
      ],
    },
    {
      section: "14. Best Practices",
      topics: [
        "Semantic HTML",
        "Accessibility (ARIA, Screen Readers, Contrast)",
        "Performance & Maintainability",
        "Internationalization and Character Encoding",
        "Validating HTML and CSS",
      ],
    },
  ];

  return (
    <div className="syllabus-container">
      <h1>HTML Syllabus</h1>
      {syllabus.map((section, idx) => (
        <div key={idx} className="syllabus-section">
          <h2>{section.section}</h2>
          <ul>
            {section.topics.map((topic, tid) => (
              <li key={tid}>{topic}</li>
            ))}
          </ul>
          <hr className="divider" />
        </div>
      ))}
    </div>
  );
};

export default HTML_Syllabus;
